function addSelectedChanges(row, textChange, previewChange, selectedRows, file) {
  let index = selectedRows.findIndex(item => item.key === row.key)
  if (selectedRows.length <= 0) {
    selectedRows.push({...row,  useForPreview: previewChange, title: textChange})
  } else if (index >= 0) {
    if ((textChange !== file[selectedRows[index].key].title && selectedRows[index].title !== file[selectedRows[index].key].title) || (previewChange !== file[selectedRows[index].key].useForPreview && selectedRows[index].useForPreview !== file[selectedRows[index].key].useForPreview)) {
      selectedRows[index].title = textChange
      selectedRows[index].useForPreview = previewChange
    } else {
      selectedRows.splice(index, 1)
    }
  } else {
    if (textChange !== file[row.key].title || previewChange !== file[row.key].useForPreview) {
      selectedRows.push({...row,  useForPreview: previewChange, title: textChange})
    }
  }
  return selectedRows
}

export {
  addSelectedChanges
}